import {Col, Row} from 'antd';
import React from 'react';

import InformativeText from '../../../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../../../utils/commonFunctions';
import LabelChart from '../../../../components/LabelChart';
import TotalChartList from '../../../../components/TotalChartList';
import ValueRepresentationBox from '../../../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../../../constants/commonConstants';
import AllSuppliers from '../../../../supplyChain/utils/AllSuppliers';

const ConsumptionWater: React.FC<{data: any[]}> = ({data}) => {
  const waterInfo = InformativeText?.NZM?.utility?.water;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(481)}}>
        <Col span={24}>
          <TotalChartList
            chartType="bar"
            showTotal={false}
            keyArray={['total water consumption']}
            data={data}
            dataInMainData={true}
            showChartList={false}
          />
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(499)}}>
        <Col span={20}>
          <TotalChartList
            chartType="line"
            showTotal={false}
            keyArray={['water consumption trends over time']}
            data={data}
            dataInMainData={true}
            showChartList={false}
          />
        </Col>
        <Col span={4}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(499)}}>
            <Col span={24}>
              <ValueRepresentationBox
                data={data}
                mainKey="water consumption per employee"
                smallImage={true}
              />
            </Col>
            <Col span={24}>
              <ValueRepresentationBox
                data={data}
                mainKey="water consumption by water scarce area"
                smallImage={true}
                tooltip={waterInfo?.Water_consumption_by_water_scarce_area}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
        <Col span={14} style={{height: '100%'}}>
          <AllSuppliers
            data={data}
            keyArray={['consumption by facility']}
            type="waterFacility"
            customTitle="TOTAL WATER CONSUMPTION"
            sumOfKey="value"
          />
        </Col>
        <Col span={10} style={{height: '100%'}}>
          <LabelChart
            data={data}
            keyArray={[
              'total water withdrawal',
              'total water discharged',
              'total water consumed'
            ]}
            customLabel="Total Withdrawal"
            chartType="pieInsideWithTotal"
          />
        </Col>
      </Row>
    </>
  );
};

export default ConsumptionWater;
